<template>
  <div>
    <footer class="footer">
      <div class="footer__section footer__section--top">
        <div class="wrapper">
          <div class="footer__columns">
            <div class="footer__column">
              <div class="footer__logo"><img src="~@/assets/images/karmabot-logo--light.svg" width="133" alt="Karmabot logo"></div>
            </div>
            <div class="footer__column footer-menu">
              <ul class="footer-menu__column">
                <li class="footer-menu__item"><a class="not-decorated" href="https://karmabot.chat/#demo">Tour</a></li>
                <li class="footer-menu__item"><a class="not-decorated" href="https://karmabot.chat/#pricing">Pricing</a></li>
                <li class="footer-menu__item"><a class="not-decorated" href="https://karmabot.chat/#features">Features</a></li>
              </ul>
              <ul class="footer-menu__column">
                <li class="footer-menu__item"><a class="not-decorated" href="https://karmabot.chat/">Slack</a></li>
                <li class="footer-menu__item"><a class="not-decorated" href="https://karmabot.chat/ms">MS Teams</a></li>
                <li class="footer-menu__item"><a class="not-decorated" href="https://karmabot.chat/telegram">Telegram</a></li>
              </ul>
              <ul class="footer-menu__column">
                <li class="footer-menu__item"><a class="footer-menu__link not-decorated" href="https://blog.karmabot.chat/" target="_blank">Blog</a></li>
                <li class="footer-menu__item"><a class="footer-menu__link not-decorated" href="https://karmabot.readme.io/v3.0/docs/billing-and-pricing-faq" target="_blank">FAQ</a></li>
                <!-- <li class="footer-menu__item"><a class="footer-menu__link show-demo" href="https://karmabot.chat/#">Demo</a></li>-->
              </ul>
              <ul class="footer-menu__column">
                <li class="footer-menu__item"><a class="footer-menu__link not-decorated" href="https://karmabot.readme.io/" target="_blank">Help</a></li>
                <li class="footer-menu__item"><a class="footer-menu__link not-decorated" href="https://karmabot.chat/explained">Use case</a></li>
                <!-- <li class="footer-menu__item"><a class="footer-menu__link js-privacy-toggle not-decorated" href="#">Privacy policy</a></li>-->
              </ul>
            </div>
          </div>
          <div class="footer__copy">Made in New Zealand 🇳🇿 at <a class="not-decorated" href="https://sliday.com" target="_blank">Sliday</a> in 2016 - 2019</div>
          </div>
      </div>
      <div class="footer__section footer__section--bottom">
        <a class="footer__sqreen" href="http://sqreen.io" target="_blank">
          <svg width="107" height="18" xmlns="http://www.w3.org/2000/svg">
            <g fill="#FFF" fill-rule="nonzero">
              <path d="M35 9.016s0 .309-.155.515c-.207.257-3.832 4.89-5.54 7.103-1.709 2.265-5.178 1.03-5.178 1.03s1.14-.67 1.864-1.545c1.916-2.419 5.592-7.155 5.592-7.155S27.907 4.331 25.99 1.86C25.318.986 24.127.316 24.127.316s3.47-1.184 5.178 1.03c1.708 2.264 5.333 6.898 5.488 7.154.207.206.207.515.207.515m-35 0s0 .31.155.516c.156.205 3.832 4.89 5.488 7.103 1.657 2.213 5.178 1.03 5.178 1.03s-1.139-.67-1.864-1.545C7.041 13.7 3.365 9.015 3.365 9.015S7.041 4.331 8.957 1.86C9.63.986 10.821.316 10.821.316S7.352-.868 5.643 1.346C3.935 3.559.363 8.244.207 8.501.052 8.758 0 9.016 0 9.016M18 3c-3.268 0-6 2.684-6 6s2.679 6 6 6 6-2.684 6-6-2.732-6-6-6M48.505 14.454c2.794 0 4.358-1.382 4.358-3.196 0-4.02-5.964-2.783-5.964-4.268 0-.556.626-.99 1.585-.99 1.23 0 2.377.516 2.982 1.155l1.064-1.794C51.529 4.577 50.173 4 48.463 4c-2.648 0-4.129 1.464-4.129 3.133 0 3.918 5.985 2.578 5.985 4.227 0 .619-.542 1.072-1.689 1.072-1.251 0-2.753-.68-3.483-1.36L44 12.907c1.063.969 2.752 1.546 4.504 1.546zm10.927-2.33c-1.501 0-2.544-1.175-2.544-2.907 0-1.711 1.043-2.886 2.544-2.886.855 0 1.836.495 2.273 1.134v3.526c-.437.618-1.418 1.134-2.273 1.134v-.001zm-.834 2.33c1.189 0 2.294-.495 3.107-1.526V18h2.67V4.248h-2.67v1.258A3.907 3.907 0 0 0 58.598 4c-2.586 0-4.463 1.896-4.463 5.216 0 3.32 1.878 5.237 4.464 5.237zm11.032-.248V7.63c.438-.639 1.606-1.133 2.481-1.133.292 0 .543.02.73.061V4.001c-1.25 0-2.502.721-3.211 1.608v-1.36h-2.649v9.957h2.649zm9.593.248c1.564 0 3.149-.474 4.15-1.382l-1.168-1.69c-.647.618-1.835.99-2.69.99-1.71 0-2.732-1.052-2.899-2.31h7.487v-.577C84.103 6.227 82.059 4 79.056 4c-3.066 0-5.214 2.33-5.214 5.216 0 3.195 2.315 5.237 5.38 5.237zm2.314-6.165h-4.963c.125-.99.834-2.206 2.482-2.206 1.752 0 2.419 1.258 2.481 2.207zm9.218 6.165c1.564 0 3.149-.474 4.15-1.382l-1.168-1.69c-.646.618-1.835.99-2.69.99-1.71 0-2.732-1.052-2.899-2.31h7.487v-.577C95.635 6.227 93.592 4 90.588 4c-3.065 0-5.213 2.33-5.213 5.216 0 3.195 2.315 5.237 5.38 5.237zm2.315-6.165h-4.964c.126-.99.835-2.206 2.482-2.206 1.752 0 2.419 1.258 2.481 2.207zM107 14.206v-7.03C107 5.238 105.936 4 103.726 4c-1.648 0-2.878.783-3.524 1.546V4.248h-2.649v9.958h2.649v-6.7c.437-.598 1.25-1.175 2.293-1.175 1.126 0 1.856.474 1.856 1.856v6.02H107z"></path>
            </g>
          </svg>
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
    export default {

    }
</script>

<style lang="sass" scoped>
  @import '../assets/styles/utils.sass'

  .footer
    position: relative
    z-index: 6
    background: #182932
    color: #fff

    .wrapper
      max-width: 1230px

    &__section

      &--top
        padding: 60px 0

        @media screen and (max-width: 970px)
          padding: 40px 0

      &--bottom
        background: #16252D
        padding: 25px 0
        text-align: center
        display: flex
        justify-content: center
        align-items: center

    &__columns
      display: flex
      flex-direction: row
      justify-content: space-between

      @media screen and (max-width: 1160px)
        flex-direction: column
        align-items: center

    &__column

      &:first-child

        @media screen and (max-width: 1160px)
          margin-bottom: 50px

        @media screen and (max-width: 500px)
          margin-bottom: 40px

      &:last-child

    &__logo

      img

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
          width: 70%

    &__copy
      font-size: 18px
      line-height: 18px
      font-weight: 500
      letter-spacing: -0.2px
      margin-top: -18px

      [lang="ru"] &

        // @media screen and (min-width: 970px) and (max-width: 1080px)
        //   max-width: 280px
        //   margin-top: -45px
        //   line-height: 26px

      @media screen and (max-width: 1160px)
        margin-top: 60px
        text-align: center
        font-size: 16px
        font-weight: 200
        letter-spacing: 0.2px

      @media screen and (max-width: 500px)
        max-width: 250px
        margin: 20px auto 0
        line-height: 24px

      a
        &:hover
          color: $lead--slack

    &__sqreen

      &:hover
        opacity: 0.75

  // Menu
  .footer-menu
    display: flex
    flex-direction: row
    font-size: 18px
    line-height: 18px
    font-weight: 500

    @media screen and (max-width: 970px)
      justify-content: center
      width: 90%

    @media screen and (max-width: 640px)
      width: 100%

    @media screen and (max-width: 500px)
      flex-direction: column

    &__column
      margin-top: 0
      margin-bottom: 0
      margin-right: 110px
      padding: 0
      display: flex
      flex-direction: column

      @media screen and (max-width: 1100px)
        margin-right: 80px

      @media screen and (max-width: 970px)
        margin: 0
        width: 30%

      @media screen and (max-width: 640px)
        width: 33%

      @media screen and (max-width: 500px)
        width: 100%
        margin-bottom: 30px

      &:last-child
        margin-right: 0

    &__item
      margin-bottom: 30px
      list-style: none

      @media screen and (max-width: 970px)
        text-align: center

      &:last-child
        margin-bottom: 0

    a
      color: inherit

      &.is-active
        cursor: default
        border-bottom: 1px solid
        color: $lead--slack

      &:hover
        color: $lead--slack
</style>
